// Import and register all your controllers for webpack
import { application } from "./application"
import { definitionsFromContext } from '@stimulus/webpack-helpers'
import { Multiselect } from '@wizardhealth/stimulus-multiselect'

// Import and register the custom Location TreeSelect controller
import LocationTreeSelectController from "./location_tree_select_controller"
application.register("location-tree-select", LocationTreeSelectController)

// Eager load all controllers defined in the import map under controllers/**/*_controller
const context = require.context('.', true, /_controller\.js$/)
application.load(definitionsFromContext(context))

// Import and register the category validator controller
import CategoryValidatorController from "./category_validator_controller"
application.register("category-validator", CategoryValidatorController)

// Import and register the service manager controller
import ServiceManagerController from "./service_manager_controller"
application.register("service-manager", ServiceManagerController)

// Import and register the video remove controller
import VideoRemoveController from "./video_remove_controller"
application.register("video-remove", VideoRemoveController)

application.register('multiselect', Multiselect)


